export default __webpack_public_path__ + "static/media/tiger.11eff803.jpg";